import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "../src/store/root/config.store";
import { ThemeProvider } from "@mui/material/styles";
import LoaderOverlay from "./components/loader-overlay/LoaderOverlay";
import App from "./App";
import theme from "./theme";
import "./index.scss";
import { initGTM } from './gtm';


initGTM(process.env.REACT_APP_GTM_ID || "", {
  addNoScriptToBody: true,
  noScriptPosition: "top",
})


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <LoaderOverlay />
      <App />
    </Provider>
  </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
